/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileNodeDto } from '../../models/file-node-dto';

export interface GetFileNode$Params {
  id: string;
}

export function getFileNode(http: HttpClient, rootUrl: string, params: GetFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDto>> {
  const rb = new RequestBuilder(rootUrl, getFileNode.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileNodeDto>;
    })
  );
}

getFileNode.PATH = '/v0/fileSystem/{id}';
